<div class="bot-msg-block" *ngIf="showContent" @fadeIn>
  <img class="chat-bot-profile" [src]="botProfilePic" alt="Chatbot Image" />
  <div class="bot-msg-risk-table">
    <div class="bot-date-time">IOA Pulse Agent {{ IssueListSRDefaultDateTime }}</div>
    <div class="option-box">
      <div class="select-box">
        <label for="date" class="filter-label">Date Range</label>
        <div class="calendar-box process-list calendar-process-list">
          <input name="date" id="date" class="custom-form-control" type="text" placeholder="Select Date" bsDaterangepicker [bsConfig]="datePickerConfig" [(ngModel)]="currentDate" (bsValueChange)="onDateRangeChange($event)" appNohtml/>
          <span
          class="clear-icon"
          *ngIf="currentDate"
          (click)="clearDates()"
          tooltip="Clear date"
        >
          &times;
        </span>
        </div>

        <div class="select-icon">
          <i class="fa-solid fa-chevron-down"></i>
        </div>
      </div>
      <div class="select-box">
        <label for="project" class="filter-label">Project</label>
        <div class="calendar-box process-list calendar-process-list">
          <select name="project" id="project" class="process-list" [(ngModel)]="currentProject"
            (ngModelChange)="onClickSwitchProject($event)">
            <option value="0" selected="true" disabled="true">Select Project</option>
            <!-- <option [ngValue]="0">Select Project</option> -->
            <option *ngFor="let project of getSortBy(projectList, 'ProjectName', 'asc')" [value]="project.ProjId">{{
              project.ProjectName }}</option>
          </select>
          <span class="clear-icon" *ngIf="currentProject && currentProject !== 0" (click)="onClearProject()"
            tooltip="Clear project">
            &times;
          </span>
        </div>
        <div class="select-icon">
          <i class="fa-solid fa-chevron-down"></i>
        </div>
      </div>

    </div>
    <div class="option-box">
      <div class="select-box">
        <label for="process" class="filter-label">Process</label>
        <div class="calendar-box process-list calendar-process-list">
          <select name="process" id="process" class="process-list" [(ngModel)]="currentProcess"
            (ngModelChange)="onProcessChange($event)">
            <option value="0" selected="true" disabled="true">Select Process</option>
            <!-- <option [ngValue]="0">Select Process</option> -->
            <option *ngFor="let process of getSortBy(processList, 'ProcessLocationName', 'asc')"
              [value]="process.ProcessId">{{ process.ProcessLocationName }}</option>
          </select>
          <span class="clear-icon" *ngIf="currentProcess && currentProcess !== 0" (click)="onClearProcess()"
            tooltip="Clear process">
            &times;
          </span>
        </div>
        <div class="select-icon">
          <i class="fa-solid fa-chevron-down"></i>
        </div>
      </div>
      <div class="select-box">
        <label for="process" class="filter-label">Associate Name</label>
        <div class="calendar-box process-list calendar-process-list">

          <select name="associate" id="associate" class="process-list" [(ngModel)]="currentUser"
            (ngModelChange)="onUserChange($event)">
            <option value="0" selected="true" disabled="true">Select Associate</option>
            <!-- <option [ngValue]="0">Select Associate</option> -->
            <option *ngFor="let user of getSortBy(associatedList, 'AssociateName', 'asc')" [value]="user.AssociateId">{{
              user.AssociateName }}</option>
          </select>
          <span class="clear-icon" *ngIf="currentUser && currentUser !== 0" (click)="onClearUser()"
            tooltip="Clear Associate">
            &times;
          </span>
        </div>
        <div class="select-icon">
          <i class="fa-solid fa-chevron-down"></i>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="main-div" *ngIf="showContent" @fadeIn>
  <div class="bot-msg-block">
    <img class="chat-bot-profile" [src]="botProfilePic" alt="Chatbot Image" />
    <div class="bot-msg">
      <div class="bot-date-time">IOA Pulse Agent {{ IssueListSRDefaultDateTime }}</div>
      <div class="accordion" id="accordionExample">
        <div class="accordion-item" *ngFor="let item of issues | keyvalue; let i = index">
          <div class="accordion-header">
            <button (click)="onClickHeader(i, radio)" class="accordion-button" [ngClass]="{ collapsed: i > 0 }" type="button"
              data-bs-toggle="collapse" [attr.data-bs-target]="'#collapse' + i" aria-expanded="true"
              [attr.aria-controls]="'collapse' + i">
              <input tooltip="Click to view issues" class="form-check-input radio" type="radio" [checked]="i == 0"
                #radio [value]="'radio-' + i" name="radiobutton" />
              <span class="no-wrap">Associate:&nbsp;<span class="sub-text">{{ getAssociateName(item.value)
                  }}</span>&nbsp;submitted issues in the system.</span>
            </button>
          </div>
          <div [id]="'collapse' + i" class="accordion-collapse collapse" [ngClass]="{ show: i == 0 }"
            data-bs-parent="#accordionExample">
            <div class="accordion-body">
              <div class="issue-div" *ngFor="let issue of getdetails(item)" [ngClass]="{ 'selected-issue': issue.IssueId === selectedIssueId }">
                <div class="message">
                  <img class="dot-pic" tooltip="1 Risk Modified" [src]="dotPic" alt="Dot" *ngIf="shouldShowDot(issue)" />
                  FLM <span class="text2">{{ getAssociateName2(issue) }}</span> has submitted the survey for Process :
                  <span tooltip="Click to view issue" class="issue-link" (click)="getNotes(issue)">{{
                    getProcessName(issue) }}</span> on <span class="text2">{{ getLocalDate(issue) }}.</span> Please
                  review and submit potential risks / issues in the system.
                </div>
                <div class="issues-block">
                  <ng-container *ngFor="let status of getAllStatusWithCount(issue)">
                    <div class="segment-open" (click)="getNotes(issue)" [title]="'Open issue (' + status?.['open'] + ')'"
                      *ngIf="status?.['open']">{{ status?.['open'] }}</div>
                    <div class="segment-wip" (click)="getNotes(issue)" [title]="'Inprogress issue (' + status?.['wip'] + ')'"
                      *ngIf="status?.['wip']">{{ status?.['wip'] }}</div>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="questions-empty" *ngIf="!checkDataOrNot()">No Data Available.</div>
        <app-chat-history-supervisor #chatHistorySection *ngIf="showChatHistory" 
        [issueIds]="chatIssueIds" [selectedConversationId]="selectedConversationId" 
        [pflmId]="selectedPFLMIdChatHistory" 
        [reasonsData]="reasonsData" 
        [impactAreaData]="impactAreaData"
         [severityData]="severityData"
        (dataLoaded)="onChatHistoryDataLoaded()"></app-chat-history-supervisor>
        <app-audit-log-risk-officer #auditLogSection *ngIf="showAuditLog" [issueIds]="auditLogIssueIds" [pflmId]="auditLogPflmId" [statusData]="allStatusData" [reasonsData]="reasonsData" [impactAreaData]="impactAreaData" [severityData]="severityData" (dataLoaded)="onAuditLogDataLoaded()"></app-audit-log-risk-officer>
      </div>
    </div>
  </div>
</div>